// extracted by mini-css-extract-plugin
export var fullWidthButton = "_g9-0";